import { jsx as n } from "react/jsx-runtime";
import l from "lz-string";
import { iconData as i } from "./icon-data.js";
function e(i) {
  return (null == i ? void 0 : i.length) > 0 && (null == i ? void 0 : i.map(function (i, o) {
    var r, t, d, c, s, a, f, u, h, v;
    var g = null !== (r = i.a) && void 0 !== r ? r : {};
    return "g" === i.n ? n("g", {
      fill: g.fill,
      children: (null === (t = i.c) || void 0 === t ? void 0 : t.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : i.n && "path" !== i.n ? "circle" === i.n ? n("circle", {
      fill: g.fill,
      id: g.id,
      cx: g.cx,
      cy: g.cy,
      r: g.r,
      opacity: g.opacity,
      children: (null === (c = i.c) || void 0 === c ? void 0 : c.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "rect" === i.n ? n("rect", {
      fill: g.fill,
      x: g.x,
      y: g.y,
      ry: g.ry,
      rx: g.rx,
      transform: g.transform,
      width: g.width,
      height: g.height,
      children: (null === (s = i.c) || void 0 === s ? void 0 : s.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "polyline" === i.n ? n("polyline", {
      fill: g.fill,
      points: g.points,
      children: (null === (a = i.c) || void 0 === a ? void 0 : a.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "line" === i.n ? n("line", {
      fill: g.fill,
      x1: g.x1,
      x2: g.x2,
      y1: g.y1,
      y2: g.y2,
      children: (null === (f = i.c) || void 0 === f ? void 0 : f.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "polygon" === i.n ? n("polygon", {
      fill: g.fill,
      points: l.decompressFromBase64(g.points),
      children: (null === (u = i.c) || void 0 === u ? void 0 : u.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "linearGradient" === i.n ? n("linearGradient", {
      id: g.id,
      gradientUnits: g.gradientUnits,
      x1: g.x1,
      y1: g.y1,
      x2: g.x2,
      y2: g.y2,
      gradientTransform: g.gradientTransform,
      children: (null === (h = i.c) || void 0 === h ? void 0 : h.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "stop" === i.n ? n("stop", {
      offset: g.offset,
      stopColor: g["stop-color"],
      children: (null === (v = i.c) || void 0 === v ? void 0 : v.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : "defs" === i.n ? n("defs", {
      children: i.c.length > 0 && e(i.c)
    }, "".concat(i.n).concat(o)) : null : n("path", {
      stroke: g.stroke,
      fill: g.fill,
      d: l.decompressFromBase64(g.d),
      children: (null === (d = i.c) || void 0 === d ? void 0 : d.length) > 0 && e(i.c)
    }, "".concat(i.n).concat(o));
  }).filter(function (n) {
    return null !== n;
  }));
}
var o = function o(l) {
  var i;
  var o = l.data,
    r = l.name,
    t = l.surface,
    d = r.toLowerCase();
  var c;
  return c = "dark" === t && ["dinersClub", "generic", "placeholder", "securityCode", "securityCodeAmex", "unionPay", "visa"].includes(d) ? o && o["".concat(d, "-inverted")] : o && o[d], n("svg", {
    viewBox: null === (i = c.a) || void 0 === i ? void 0 : i.v,
    width: "100%",
    style: {
      backgroundColor: "discover" === d && "dark" === t ? "#FFFFFF" : void 0
    },
    children: e(c.c)
  });
};
o.defaultProps = {
  data: i
};
export { o as default, e as mapChildren };